import { Helper, Image } from 'Components';
import i18n from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import BureauVeritasLogo from 'src/assets/maxxam-logo-black.svg';
import './LabelPreview.css';

const LabelPreview = props => (
  <div className="label-preview">
    { props.title && <div className="label-preview__title">{props.title}</div> }
    <div className="label-preview__header">
      <div className="label-preview__header__logo">
        <Image src={BureauVeritasLogo} alt="BureauVeritas Logo" />
      </div>
      <div className="label-preview__header__right">
        <Helper text={i18n.t('tutorials:orders.bottleOrderNumber')}>
          <div>B.O. # : <strong>{!props.isBlank ? props.orderNumber : ''}</strong></div>
        </Helper>
      </div>
    </div>

    <div className="label-preview__main">
      <div className="label-preview__main__content">
        <div>{i18n.t('labelPreview:SAMPLE ID')} :</div>
        <strong>{!props.isBlank && props.sampleID}</strong>
      </div>
      <div className="label-preview__main__content">
        <div>{i18n.t('labelPreview:COMPANY NAME')} :</div>
        <strong>{!props.isBlank && props.companyName}</strong>
      </div>
      <div className="label-preview__main__content">
        <div>{i18n.t('labelPreview:PROJECT REFERENCE')} :</div>
        <strong>{!props.isBlank && props.projectReference}</strong>
      </div>
      <div className="label-preview__main__content">
        <div>{i18n.t('labelPreview:DATE')} :</div>
        <strong>{!props.isBlank && props.date}</strong>
      </div>
    </div>
  </div>
);
LabelPreview.propTypes = {
  isBlank: PropTypes.bool,
  title: PropTypes.string,
  orderNumber: PropTypes.string,
  date: PropTypes.string,
  sampleID: PropTypes.string,
  companyName: PropTypes.string,
  projectReference: PropTypes.string,
};

export default LabelPreview;



// WEBPACK FOOTER //
// ./src/components/LabelPreview/LabelPreview.jsx